import * as React from 'react';
import { BrowserRouter, Route, Link, Switch, Redirect, withRouter } from "react-router-dom";
import Translate from '../../common/functions/translate';
import { connect } from 'react-redux';
import * as Constants from '../../common/constants';
import * as actionTypes from '../../store/actionTypes';
import AuthService from '../../services/authService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronRight, faUser, faUsers, faTablets, faNotesMedical, faCog, faPills, faCookie,
  faPrescription, faHeartbeat, faSignOutAlt, faDatabase, faStethoscope, faVial
} from '@fortawesome/free-solid-svg-icons';
import ConfirmDialog from '../../common/components/confirmDialog/confirmDialog';

interface IProps {
  lang: string,
  history: any,
  isUserLogged: boolean,
  onUserLogout: any,
  onDrawarMenuLogoutClick: any
}

interface IState {
  isVisibleConfirmDialog: boolean;
}

class MenuNavigation extends React.Component<IProps, IState> {

  аuthService = new AuthService();

  constructor(props: IProps) {
    super(props);

    this.state = {
      isVisibleConfirmDialog: false
    };
  }

  handleLogout = () => {
    this.props.onDrawarMenuLogoutClick();
  }

  handleMenuItemClick = (menuUrl) => {
    this.props.history.push(menuUrl);
  }

  componentDidUpdate(prevProps) {
  }

  public render() {

    const UserMenus =
      <>
        <li key='Profile' onClick={() => this.handleMenuItemClick('/user/profile')}>
          <div className="item-icon">
            <FontAwesomeIcon icon={faUser} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('Profile')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>

        <li key='My Medicines' onClick={() => this.handleMenuItemClick('/user/medicines')}>
          <div className="item-icon">
            <FontAwesomeIcon icon={faPills} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('My Medicines')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>

        <li key='My Diseases' onClick={() => this.handleMenuItemClick('/user/diseases')}>
          <div className="item-icon">
            <FontAwesomeIcon icon={faStethoscope} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('My Diseases')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>

        <li key='My Prescriptions' onClick={() => this.handleMenuItemClick('/user/prescriptions')}>
          <div className="item-icon">
            <FontAwesomeIcon icon={faPrescription} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('Doctors prescriptions')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>

        <li key='My Condition' onClick={() => this.handleMenuItemClick('/user/condition')}>
          <div className="item-icon">
            <FontAwesomeIcon icon={faHeartbeat} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('My Condition')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>

        <li key='My Family' onClick={() => this.handleMenuItemClick('/user/family')}>
          <div className="item-icon">
            <FontAwesomeIcon icon={faUsers} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('My Family')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>

        <li key='Lab Results' onClick={() => this.handleMenuItemClick('/user/labresults')}>
          <div className="item-icon">
            <FontAwesomeIcon icon={faVial} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('Laboratory result')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>

        <li key='Logout'
          onClick={this.handleLogout}
        >
          <div className="item-icon">
            <FontAwesomeIcon icon={faSignOutAlt} />
          </div>
          <div className="item-info">
            <div className="item-name">
              {Translate('Logout')}
            </div>
          </div>
          <div className="item-actions">
            <FontAwesomeIcon icon={faChevronRight} />
          </div>
        </li>
      </>;

    return (
      <>

        <div className="app-content" style={{ minWidth: '280px' }}>

          <h2>
            {this.аuthService.isAuthenticated() ?
              <div onClick={() => this.handleMenuItemClick('/user/dashboard')} className="menu-dashboard">
                <span>{this.аuthService.getUserName()}</span>
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
              : Translate('Menu')}
          </h2>

          <ul className="list-items" style={{ marginBottom: '40px' }}>

            {this.аuthService.isAuthenticated() ?
              UserMenus :
              <li key='Login' onClick={() => this.handleMenuItemClick('/login')}>
                <div className="item-icon">
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <div className="item-info">
                  <div className="item-name">
                    {Translate('Login')}
                  </div>
                </div>
                <div className="item-actions">
                  <FontAwesomeIcon icon={faChevronRight} />
                </div>
              </li>
            }

          </ul>

          <ul className="list-items" style={{ marginBottom: '40px' }}>

            <li key='cookie' onClick={() => this.handleMenuItemClick('/cookie-policy')}>
              <div className="item-icon">
                <FontAwesomeIcon icon={faCookie} />
              </div>
              <div className="item-info">
                <div className="item-name">
                  {Translate('Cookies Policy')}
                </div>
              </div>
              <div className="item-actions">
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </li>

            <li key='personal' onClick={() => this.handleMenuItemClick('/personal-data-policy')}>
              <div className="item-icon">
                <FontAwesomeIcon icon={faDatabase} />
              </div>
              <div className="item-info">
                <div className="item-name">
                  {Translate('Personal Data Policy')}
                </div>
              </div>
              <div className="item-actions">
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </li>

          </ul>

          <ul className="list-items" style={{ marginBottom: '40px' }}>

            <li key='Settings' onClick={() => this.handleMenuItemClick('/settings')}>
              <div className="item-icon">
                <FontAwesomeIcon icon={faCog} />
              </div>
              <div className="item-info">
                <div className="item-name">
                  {Translate('Settings')}
                </div>
              </div>
              <div className="item-actions">
                <FontAwesomeIcon icon={faChevronRight} />
              </div>
            </li>

          </ul>

          <div className="app-footer">
            <div>
              © {new Date().getFullYear()} ICB - InterConsult Bulgaria.
          </div>
            <div>
              All rights reserved.
          </div>
            <div>
              ver. {process.env.REACT_APP_VERSION} ({process.env.NODE_ENV})
          </div>
          </div>
        </div>
      </>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang,
    isUserLogged: state.common.isUserLogged
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onUserLogout: () => dispatch({ type: actionTypes.USER_LOGOUT }),
  }
}

export default withRouter(connect(mapsStateToProps, mapDispatchToProps)(MenuNavigation));